"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TokenSourceWithOidc = void 0;
var _webautoAuthCore = require("@tier4/webauto-auth-core");
class TokenSourceWithOidc {
  tokenSource = null;
  constructor(tokenService, userManager, bearerStore, logger) {
    this.tokenService = tokenService;
    this.userManager = userManager;
    this.bearerStore = bearerStore;
    this.logger = logger;
  }
  async getToken() {
    const tokenSource = await this.getAuthTokenSource();
    return tokenSource.getToken();
  }
  async getAuthTokenSource() {
    if (!this.tokenSource) {
      this.logger.debug({
        caller: "TokenSourceWithOidc.getAuthTokenSource",
        message: "creating new token source."
      });
      this.tokenSource = new _webautoAuthCore.TokenSource(this.tokenService, async () => _webautoAuthCore.TokenRequestBuilder.idTokenExchange({
        get_id_token: async () => {
          const user = await this.userManager.getUser();
          let token = (user === null || user === void 0 ? void 0 : user.id_token) ?? "";
          if (!user || user.expired === true || !token) {
            const renewedUser = await this.userManager.signInSilent();
            if (!(renewedUser !== null && renewedUser !== void 0 && renewedUser.id_token)) throw new _webautoAuthCore.SessionError("Not found valid ID Token. Please restart from login.");
            token = renewedUser.id_token;
          }
          return token;
        }
      }), this.bearerStore, this.logger);
    }
    return this.tokenSource;
  }
}
exports.TokenSourceWithOidc = TokenSourceWithOidc;
//# sourceMappingURL=TokenSourceWithOidc.js.map